import { useEffect, useState } from "react";

export default () => {
    const [scrollPosition, setScrollPosition] = useState(true);
    const [_height, setHeight] = useState(0);

    useEffect(() => {
        window.addEventListener("scroll", listenToScroll);
        return () => window.removeEventListener("scroll", listenToScroll);
    }, []);

    const listenToScroll = () => {
        let heightToHideFrom = 0;
        const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        setHeight(winScroll);

        if (winScroll < heightToHideFrom) {
            scrollPosition && setScrollPosition(false);
        } else {
            setScrollPosition(true);
        }
    };

    return { scrollPosition };
};
